import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3","key":"svg-0"}],["path",{"d":"M11 11a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-1"}],["path",{"d":"M12 12l0 2.5","key":"svg-2"}]]

const IconShieldLock = createReactComponent('outline', 'shield-lock', 'ShieldLock', __iconNode);

export default IconShieldLock;